import { render, staticRenderFns } from "./editModel.vue?vue&type=template&id=2a939df5&scoped=true&"
import script from "./editModel.vue?vue&type=script&lang=js&"
export * from "./editModel.vue?vue&type=script&lang=js&"
import style0 from "./editModel.vue?vue&type=style&index=0&id=2a939df5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a939df5",
  null
  
)

export default component.exports